import script from "./CreateAGroupTalkWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAGroupTalkWizard.vue?vue&type=script&setup=true&lang=js"

import "./CreateAGroupTalkWizard.vue?vue&type=style&index=0&id=76a12afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a12afa"]])

export default __exports__